<template>
    <div>
        <ynav title="查询结果"></ynav>
        <div class="jieguolist">
            <h2>查询到2个结果</h2>
            <ul class="bgb">
                 <li v-for="item in producerList" @click="pick(item)" :key="item">
                    <h3>{{item.NameCN}}</h3>
                    <p>{{item.CompanyName}}</p>
                    <p>{{item.CodeName}}</p>
                 </li>
               
                <li>
                    <h3>水痘疫苗</h3>
                    <p>上海生物制品研究所有限责任公司</p>
                    <p>20170406-1</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import * as api from "../libs/api";
import  ynav from "../components/nav";

export default {
  components: {
    ynav
  },
  data() {
    return {
          producerList:[]
    };
  },
  methods: {
    init() {
        if(this.$store.state.result)
        {
            this.producerList=this.$store.state.result;
        }
        else
        {
             this.$router.push({ name: 'Index'});
        }
    }
  },

  mounted() {
    this.init();
  }
};
</script>




// WEBPACK FOOTER //
// src/views/MultiMacheing.vue